import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'hom-hom',
  templateUrl: './hom.component.html',
  standalone: false
}) export class HomComponent implements OnDestroy  {

  public ngOnDestroy(): void {
    // No manual unsubscribe needed when using takeUntilDestroyed
  }
}
